export default {
  DatePicker: {
    lang: {
      locale: 'th',
      placeholder: 'เลือกวันที่',
      rangePlaceholder: ['วันเริ่มต้น', 'วันสิ้นสุด'],
      today: 'วันนี้',
      now: 'ตอนนี้',
      backToToday: 'กลับไปวันนี้',
      ok: 'ตกลง',
      clear: 'ล้าง',
      month: 'เดือน',
      year: 'ปี',
      timeSelect: 'เลือกเวลา',
      dateSelect: 'เลือกวันที่',
      monthSelect: 'เลือกเดือน',
      yearSelect: 'เลือกปี',
      decadeSelect: 'เลือกทศวรรษ',
      yearFormat: 'YYYY',
      dateFormat: 'D MMMM YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D MMMM YYYY HH:mm:ss',
      monthFormat: 'MMMM',
      monthBeforeYear: true,
      previousMonth: 'เดือนก่อนหน้า',
      nextMonth: 'เดือนถัดไป',
      previousYear: 'ปีก่อนหน้า',
      nextYear: 'ปีถัดไป',
      previousDecade: 'ทศวรรษก่อนหน้า',
      nextDecade: 'ทศวรรษถัดไป',
      previousCentury: 'ศตวรรษก่อนหน้า',
      nextCentury: 'ศตวรรษถัดไป',
      shortWeekDays: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
      shortMonths: [
        'ม.ค.',
        'ก.พ.',
        'มี.ค.',
        'เม.ย.',
        'พ.ค.',
        'มิ.ย.',
        'ก.ค.',
        'ส.ค.',
        'ก.ย.',
        'ต.ค.',
        'พ.ย.',
        'ธ.ค.',
      ],
      fullWeekDays: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'],
      fullMonths: [
        'มกราคม',
        'กุมภาพันธ์',
        'มีนาคม',
        'เมษายน',
        'พฤษภาคม',
        'มิถุนายน',
        'กรกฎาคม',
        'สิงหาคม',
        'กันยายน',
        'ตุลาคม',
        'พฤศจิกายน',
        'ธันวาคม',
      ],
    },
    timePickerLocale: {
      placeholder: 'เลือกเวลา',
    },
  },
}
